<template>
<!-- 消息/文案管理-网站公告 -->
  <div class="message">
    <el-form :inline="true" class="demo-form-inline">
      <el-form-item>
        <el-button size="small" type="primary" @click="visibleAdd = true"
          >添加公告</el-button
        >
      </el-form-item>
    </el-form>
    <el-form :inline="true" class="demo-form-inline">
      <el-form-item>
        <el-select size="small" v-model="params.type">
          <el-option :value="1" label="网站公告"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-input
          size="small"
          v-model="params.contents"
          placeholder="请输入关键词"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" @click="handleSearch"
          >搜索</el-button
        >
      </el-form-item>
    </el-form>
    <el-table :data="listData" v-loading="loading">
      <el-table-column prop="id" label="ID"></el-table-column>
      <el-table-column prop="type" label="消息类型">
        <template slot-scope="scope">
          <span v-if="scope.row.type === 1">网站公告</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="content"
        width="600"
        label="消息内容"
      ></el-table-column>
      <el-table-column prop="remark" label="关联文章ID"></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button size="small" type="primary" @click="handleEdit(scope.row)"
            >编辑</el-button
          >
          <el-button
            size="small"
            type="danger"
            @click="handleDelete(scope.row.id)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      :page-size="listMeta ? listMeta.per_page : 20"
      :total="listMeta ? listMeta.total : 0"
      :current-page="page"
      @current-change="handlePageChange"
      v-if="listMeta && listMeta.total > listMeta.per_page"
    ></el-pagination>
    <MessageDetail
      :visible="visibleAdd"
      :data="undefined"
      @close="visibleAdd = false"
      @refresh="getTableData"
    ></MessageDetail>
    <MessageDetail
      :visible="visibleEdit"
      :data="currentData"
      @close="visibleEdit = false"
      @refresh="getTableData"
    ></MessageDetail>
  </div>
</template>

<script>
import { server, delData, getData, patchData, postData, getApiData, patchApiData } from '@/http'
import { getCookie } from '@/utils/cookie'
import MessageDetail from './MessageDetail'

export default {
  components: {
    MessageDetail,
  },
  data() {
    return {
      loading: false,
      listData: undefined,
      listMeta: undefined,
      params: {
        page: 1,
        contents: '',
        type: 1
      },
      visibleAdd: false,
      visibleEdit: false,
      currentData: undefined
    }
  },
  computed: {
    headers() {
      return {
        Authorization: 'Bearer ' + getCookie('access_token')
      }
    },
    action() {
      return `${server}send_news_export`
    }
  },
  methods: {
    getTableData() {
      this.loading = true
      getData('messages', { ...this.params })
        .then(res => {
          this.listData = res.data
          this.listMeta = res.meta
        })
        .finally(() => {
          this.loading = false
        })
    },
    handlePageChange(page) {
      this.params.page = page
      this.getTableData()
    },
    handleSearch() {
      this.params.page = 1
      this.getTableData()
    },
    handleEdit(data) {
      this.currentData = data
      this.visibleEdit = true
    },
    handleDelete(id) {
      delData(`messages/${id}`).then(
        () => {
          this.$message.success('删除成功')
          this.getTableData()
        }
      )
    },
  },
  created() {
    this.getTableData()
  }
}
</script>
